import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { BookDto } from './model.dto'

@ObjectType()
export class BookPagedResultDto extends PaginatedResponse(BookDto) {
}
